export default {
  'media.categories': 'Categorías',
  'media.title': 'Gestionar Media',
  'media.fileName': 'Nombre de archivo',
  'media.document': 'Documento',
  'media.fileType': 'Tipo de archivo',
  'media.fileTypeClassification': 'Clasificación tipo archivo',
  'media.fileTypeClassification.unknown': 'Desconocido',
  'media.fileTypeClassification.image': 'Imagen',
  'media.fileTypeClassification.video': 'Video',
  'media.fileTypeClassification.pdf': 'PDF',
  'media.fileTypeClassification.word': 'Word',
  'media.fileTypeClassification.excel': 'Excel',
  'media.fileTypeClassification.powerPoint': 'PowerPoint',
  'media.fileTypeClassification.microsoftProject': 'Microsoft Project',
  'media.fileTypeClassification.text': 'Texto',
  'media.fileTypeClassification.xml': 'XML',
  'media.fileTypeClassification.html': 'HTML',
  'media.fileTypeClassification.json': 'JSON',
  'media.fileTypeClassification.zip': 'ZIP',
  'media.fileTypeClassification.audio': 'Audio',
  'media.fileTypeClassification.rar': 'RAR',
  'media.fileTypeClassification.font': 'Fuente',
  'media.fileTypeClassification.textCsv': 'CSV',
  'media.fileTypeClassification.androidApk': 'Android APK',
  'media.fileTypeClassification.exeFile': 'EXE',
  'media.fileTypeClassification.parquetFile': 'Parquet',
  'media.fileTypeClassification.outlookMessage': 'Mensaje Outlook',
  'media.fileTypeClassification.markdown': 'Markdown',
  'media.ownerType': 'Tipo de propietario',
  'media.ownerType.generic': 'Genérico',
  'media.ownerType.app': 'Aplicación',
  'media.ownerType.process': 'Proceso',
  'media.ownerType.chat': 'Chat',
  'media.size': 'Tamaño',
  'media.eTag': 'eTag',
  'media.ownerDisplay': 'Propietario (visualización)',
  'media.tags': 'Etiquetas',
};
